<div
  class="icon-container"
  [style.width]="width + 'px'"
  [style.height]="height + 'px'"
>
  <svg [attr.preserveAspectRatio]="'xMidYMid meet'" width="100%" role="img">
    <use [attr.xlink:href]="'#' + icon"></use>
  </svg>
</div>
